import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {
  AddressInformation,
  ConfigService,
  CspType,
  formatPatientDemographicsAddress,
  formatPatientDemographicsBirthdate,
  formatPatientDemographicsName,
  PatientDemographics,
} from '@shared-library';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent {
  readonly CspType = CspType;

  get patientDemographics(): PatientDemographics {
    return this.configService.vaultProfileConfigSubject.value.verifiedIdentityPatientDemographics!;
  }

  get identityProviderName(): string {
    return this.configService.vaultProfileConfigSubject.value.verifiedIdentityCspType === CspType.IdmeCsp
      ? 'ID.me'
      : 'Clear';
  }

  constructor(public configService: ConfigService) {}

  getVerifiedPatientName(demographics?: PatientDemographics | null): string {
    return formatPatientDemographicsName(demographics);
  }

  getVerifiedPatientAddress(address?: AddressInformation | null): string {
    return formatPatientDemographicsAddress(address);
  }

  getVerifiedBirthdate(demographics?: PatientDemographics | null): string {
    return formatPatientDemographicsBirthdate(demographics);
  }
}
